import { NavLink } from "react-router-dom";
import { useMediaQuery } from "../../Libs/hookLibs";
import Star from "../../Res/MB-star_n_web.svg";
import Claim from "../../Res/MB-wm_no-claim_ra_n_web.svg";

export const Logo = () => {
	const isTablet = useMediaQuery("(min-width: 768px)");
	const isDesktop = useMediaQuery("(min-width: 1024px)");

	return (
		<div
			style={{
				height: "100%",
				display: "flex",
				flexDirection: "row",
				justifyContent: isDesktop ? "flex-start" : "center",
				height: isTablet || isDesktop ? "64px" : "40px",
				padding: isTablet || isDesktop ? "16px" : "20px",
			}}
		>
			<NavLink
				exact
				to={"/"}
				style={{
					display: "flex",
					flexDirection: "row",
				}}
			>
				<div
					style={{
						height: "100%",
						width: isTablet || isDesktop ? "64px" : "40px",
					}}
				>
					<img
						src={Star}
						style={{
							height: "100%",
							width: "100%",
						}}
					/>
				</div>
				<div
					style={{
						marginLeft: "64px",
						width: "112px",
						display: isDesktop ? "initial" : "none",
						position: "relative",
					}}
				>
					<img
						src={Claim}
						style={{
							height: "100%",
							width: "100%",
							position: "absolute",
							top: "14px",
						}}
					/>
				</div>
			</NavLink>
		</div>
	);
};
